module.exports = __webpack_public_path__ + "static/media/arrow.a3cef639.svg";